var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIceCream1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9,4.02a5.008,5.008,0,0,0-9.8,0,5.506,5.506,0,0,0-4.325,8.257L9.019,22.333a3.521,3.521,0,0,0,5.96,0L21.24,12.253A5.507,5.507,0,0,0,16.9,4.02ZM20,9.5a3.331,3.331,0,0,1-.056.573,34.663,34.663,0,0,1-6.624.884C11.329,5.647,19.593,3.842,20,9.5ZM12,2a3,3,0,0,1,2.893,2.249A5.52,5.52,0,0,0,12,6.341,5.52,5.52,0,0,0,9.107,4.249,3,3,0,0,1,12,2ZM7.5,6a3.517,3.517,0,0,1,3.181,4.955,35.968,35.968,0,0,1-6.624-.88A3.5,3.5,0,0,1,7.5,6Zm5.778,15.286a1.54,1.54,0,0,1-2.558,0L5.17,12.346a37.938,37.938,0,0,0,13.656,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceCream1);
export default __webpack_public_path__ + "static/media/ice-cream (1).b3d80e0bb55de9ce9908a4cc5361e983.svg";
export { ForwardRef as ReactComponent };